<script>
	import { getNewIcon } from "../../card_images";

	export let value;

	function getSize(i){
		return `calc(var(--height) / ${401 / i})`;
	}
</script>

<div class="skill-badge-tre">
	<div class="skill tre"
		style="--iconSize:{getSize(24)};--hTranslate:-35%;"
	>
		<img src={getNewIcon('treachery')} />
		<span class="font-block tre-value">{value}</span>
	</div>
</div>

<style lang="scss">
	$tre-main: rgba(189, 107, 11, 1);
	$tre-secondary: rgba(117, 63, 0, 1);
	.skill-badge-tre {
		height: calc(var(--height) / 12.531); //32px;
		width: calc(var(--height) / 5.128); //78px;
		overflow: hidden;
		flex-direction: column;
		clip-path: polygon(100% 0%, 80% 50%, 100% 100%, 0 100%, 0% 50%, 0 0);
		color: white;
	}
	.skill.tre {
		flex-grow: 1;
		flex-direction: row;
		align-items: center;
		padding-left: calc(var(--width) / 19.133); //15px;
		gap: calc(var(--width) / 143.5); /*2px;*/
		//box-shadow: inset 18px 0 15px -10px $tre-main, inset -20px 0 15px -10px $tre-main;
		box-shadow: inset calc(var(--height) / 22.278) 0 calc(var(--height) / 26.667) calc(0px - var(--height) / 40.1) $tre-main, inset calc(0px - var(--height) / 20.05) 0 calc(var(--height) / 26.667) calc(0px - var(--height) / 22.278) $tre-main;
		background: linear-gradient(
			0deg,
			$tre-main 0%,
			$tre-secondary 25%,
			$tre-main 50%,
			$tre-secondary 75%,
			$tre-main 100%
		);
		& > :global(img) {
			height: var(--iconSize);
			z-index: 10;
		}
	}
</style>
